// src/firebase.js
import { initializeApp, getApps } from "firebase/app";

// ✅ Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBMsHPyp8T8mLWozojryCSdIYRCHp06Gfo",
  authDomain: "pottsboro-basketball.firebaseapp.com",
  projectId: "pottsboro-basketball",
  storageBucket: "pottsboro-basketball.firebasestorage.app",
  messagingSenderId: "944986180367",
  appId: "1:944986180367:web:6a88d01d122f77b3438c7a",
};

// ✅ Initialize only once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

export default app;
